import { useSnackbar } from 'notistack';
import { useMutation } from 'react-query';

import { axios } from 'lib';

const reorderLevels = (resource, id, { structureId, levelIds }) => {
  return axios.put(`/api/${resource}/${id}/setup/level_structures/${structureId}/order`, {
    level_ids: levelIds,
  });
};

export const useReorderLevels = (resource, id, onSuccess) => {
  const { enqueueSnackbar } = useSnackbar();

  return useMutation({
    mutationFn: (values) => reorderLevels(resource, id, values),
    onSuccess: () => {
      onSuccess();
    },
    onError: (error) => {
      enqueueSnackbar(
        error?.response?.data?.description || error?.message || 'Some error occured',
        {
          variant: 'error',
        }
      );
    },
  });
};
